<p>simple-import-payments works!</p>
